/* shani-collection: פס סינון דביק, צ'יפי מידה ומגירת סינון (מפרט §3).
   מקור האמת לבחירה הנוכחית הוא ה-URL. מונים חיים: Section Rendering API על הסקשן עם הבחירה הממתינה.
   אבטחה: כל ערך שמגיע מהחנות (שם מותג, מידת נעליים, שם צבע) עובר esc() לפני שנכנס ל-HTML. השאר קבועים או מספרים.
   עמוד הקטגוריה:
   - A2: כל כתובת נבנית ב-buildUrl() עם URL/URLSearchParams. collection.url של עמוד מותג כבר מכיל ?q=, ושרשור '?' אחריו היה 404.
   - C1: בחירת מידה, מיון, הסרת צ'יפ ו"הצגת N פריטים" מחליפים את הרשת במקום (Section Rendering, בקשה אחת לשני הסקשנים),
     עם משוב מיידי, AbortController, pushState/popstate, ונפילה לניווט מלא בכשל או אחרי 6 שניות.
     ה-<ul> של הרשת לא מוחלף (עליו יושבים המשקיפים של התבנית, של שומר הסל ושלנו). מוחלפים רק ה-<li> ואזור העימוד.
   - C2: קבוצת צבע וכפתור צבע, פעילים רק כשהשרת מצא מסנן צבע ב-collection.filters (data.color).
   - A4: הטעינה האוטומטית של התבנית לא נדלקת כשאזור העימוד כבר מעל המסך (גלילה בפוטר).
   - בקשת ה-sections בלי כותרת Accept: עם application/json שופיפיי מחזירה את ה-JSON של הקולקציה ולא את הסקשנים.
   - אצוות הגלילה של התבנית לא נוחתת ברשת מסוננת (אחיזה על קישור העימוד בזמן החלפה; אצווה שכבר בדרך: ניווט מלא).
   - העמעום משתחרר תמיד (8 שניות אחרי נפילה לניווט מלא שלא התבצע).
   - מיון שבדרך וסינון שבדרך לא דורסים זה את זה (sortTarget).
   - מצב "בסל" בכרטיס עוקב אחרי אירוע cart-update של התבנית: נדלק מיד, ויורד כשהפריט הוסר מהסל.
   - _su_rec ו-_su_rec_id לא נגררים לכתובות שנבנות; הטקסט המוסתר חוזר אחרי הסרה; aria-disabled מהלחיצה. */
(function () {
  var root = document.querySelector('[data-shc]');
  if (!root) return;

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var SIZE_P = function (k) { return 'filter.p.m.next_cart.size_' + k.toLowerCase(); };
  var SHOE_P = 'filter.p.m.next_cart.d79ed799d793d7aa-d7a0d7a2d79cd';
  var VEND_P = 'filter.p.vendor';
  var sectionId = root.getAttribute('data-section');
  var shoeCol = root.getAttribute('data-shoecol') === 'true';
  var BUCKETS = (root.getAttribute('data-buckets') || '').split(',').map(function (b) {
    var p = b.trim().split('-'); return { lo: p[0] === '' ? null : parseFloat(p[0]), hi: p[1] === '' || p[1] == null ? null : parseFloat(p[1]) };
  }).filter(function (b) { return b.lo !== null || b.hi !== null; });
  function bucketLabel(b) {
    if (!b.lo) return 'עד ' + Math.ceil(b.hi);
    if (b.hi === null) return Math.round(b.lo) + '+';
    return Math.round(b.lo) + '–' + Math.ceil(b.hi);
  }
  /* "150+ ₪" ב-RTL מתהפך ל-"₪ +150". תווית שמתחילה בספרה נעטפת ב-bdi dir=ltr */
  function ltr(html, raw) { return /^\d/.test(raw) ? '<bdi dir="ltr">' + html + '</bdi>' : '<bdi>' + html + '</bdi>'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(n) { return String(Number(n) || 0); }
  /* ערכי מסנן מגיעים משופיפיי כשהם כבר מקודדים (H&amp;M). מפענחים פעם אחת, וכך ה-URL והתצוגה מקבלים את הערך האמיתי */
  var decEl = document.createElement('textarea');
  function dec(s) { decEl.innerHTML = String(s); return decEl.value; }
  /* ערך נעליים עם פסיק ("36, 35") מוצג כטווח ממוין ("35-36") */
  function tidy(t) { return /,/.test(t) ? t.split(',').map(function (x) { return x.trim(); }).filter(Boolean).sort(function (a, b) { return parseFloat(a) - parseFloat(b); }).join('-') : t; }
  function decList(a) { return (a || []).map(function (x) { return { k: dec(x.k), t: tidy(dec(x.t || x.k)), n: x.n, a: x.a }; }); }
  function parseData(txt) {
    var d = JSON.parse(txt);
    d.vendors = decList(d.vendors); d.shoes = decList(d.shoes);
    if (d.color && d.color.p) {
      d.color.values = (d.color.values || []).map(function (x) { return { k: dec(x.k), t: dec(x.t || x.k), n: x.n, a: x.a, c: x.c || '' }; });
    } else { d.color = null; }
    return d;
  }
  function shoeLabel(v) { var f = (data0 && data0.shoes || []).find(function (x) { return x.k === v; }); return f ? f.t : v; }
  var data0 = parseData(root.querySelector('[data-shc-data]').textContent);
  /* שם הפרמטר של מסנן הצבע מגיע מהשרת (מה שמוגדר ב-Search & Discovery). בלי מסנן צבע: null, ושום דבר של צבע לא רץ */
  var COLOR_P = data0.color ? data0.color.p : null;

  /* ===== צבע: 14 המשפחות וגוני העיגול. הגוון הוא גרפיקה, לא צבע מותג ===== */
  var FAMILIES = [
    { bg: '#1E1E1E', he: ['שחור'], en: ['black'] },
    { bg: '#2F5DA8', he: ['כחול'], en: ['blue', 'navy', 'denim'] },
    { bg: '#FFFFFF', light: 1, he: ['לבן'], en: ['white'] },
    { bg: '#E8DCC6', light: 1, he: ['שמנת', 'בז'], en: ['beige', 'cream', 'ivory', 'nude', 'ecru'] },
    { bg: 'linear-gradient(135deg,#B88C2D 50%,#C4C4C4 50%)', light: 1, he: ['זהב', 'כסף'], en: ['gold', 'silver', 'metallic'] },
    { bg: 'conic-gradient(#C0392B 0 25%,#D9B21F 0 50%,#4E7D4A 0 75%,#2F5DA8 0)', he: ['צבעוני', 'הדפס'], en: ['multicolor', 'multicolour', 'multi', 'print', 'printed', 'pattern', 'floral', 'striped'] },
    { bg: '#E79AB5', light: 1, he: ['ורוד'], en: ['pink', 'rose'] },
    { bg: '#4E7D4A', he: ['ירוק'], en: ['green', 'olive', 'khaki'] },
    { bg: '#7A5236', he: ['חום'], en: ['brown', 'tan', 'camel'] },
    { bg: '#8E8E8E', he: ['אפור'], en: ['gray', 'grey'] },
    { bg: '#C0392B', he: ['אדום'], en: ['red', 'burgundy', 'bordeaux'] },
    { bg: '#D9B21F', light: 1, he: ['צהוב', 'חרדל'], en: ['yellow', 'mustard'] },
    { bg: '#7B4FA0', he: ['סגול'], en: ['purple', 'violet', 'lilac'] },
    { bg: '#E07B2A', he: ['כתום'], en: ['orange', 'coral'] }
  ];
  function hexLight(h) {
    var m = /^#([0-9a-f]{6})$/i.exec(h); if (!m) return false;
    var n = parseInt(m[1], 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) > 170;
  }
  /* העיגול: קודם משפחה לפי שם הערך (עברית: המילה מופיעה בשם; אנגלית: מילה שלמה), אחר כך הגוון ששופיפיי מחזירה, ואם אין: ניטרלי */
  function swatch(c) {
    var t = String(c.t || '').toLowerCase(), words = t.split(/[^a-z]+/), i, j;
    for (i = 0; i < FAMILIES.length; i++) {
      var f = FAMILIES[i];
      for (j = 0; j < f.he.length; j++) if (t.indexOf(f.he[j]) >= 0) return { bg: f.bg, light: !!f.light };
      for (j = 0; j < f.en.length; j++) if (words.indexOf(f.en[j]) >= 0) return { bg: f.bg, light: !!f.light };
    }
    if (/^#[0-9a-f]{6}$/i.test(c.c || '')) return { bg: c.c, light: hexLight(c.c) };
    return { bg: '#E4E0DA', light: true };
  }
  function colorObj(k) { var f = data0.color && data0.color.values.find(function (x) { return x.k === k; }); return f || { k: k, t: k, n: 0, c: '' }; }
  function colorName(k) { return colorObj(k).t; }

  /* ===== מצב מתוך ה-URL ===== */
  /* fix2: בחזרה מפריט שופיפיי יכולה להוסיף לכתובת _su_rec ו-_su_rec_id (הפניה דרך shop.app). הם לא חלק מהמצב ולא נגררים
     לכתובות הסינון, המיון והעימוד. מסירים רק אותם, ושאר הכתובת נשאר תו בתו (אותה פונקציה כמו ב-collection-scroll-restore.js) */
  function stripSu(search) {
    var parts = String(search || '').replace(/^\?/, '').split('&').filter(function (kv) { var k = kv.split('=')[0]; return kv !== '' && k !== '_su_rec' && k !== '_su_rec_id'; });
    return parts.length ? '?' + parts.join('&') : '';
  }
  function urlNow() { var u = new URL(location.href); u.search = stripSu(location.search); return u; }
  var here = urlNow();
  var sortTarget = null;
  function readSel(u) {
    var s = { size: null, brands: [], shoes: [], colors: [], price: null, order: [] };
    u.searchParams.forEach(function (v, k) {
      if (k.indexOf('filter.p.m.next_cart.size_') === 0) { if (!s.size && SIZE_ORDER.indexOf(v) >= 0) { s.size = v; s.order.push(['size', v]); } }
      else if (k === VEND_P) { s.brands.push(v); s.order.push(['brand', v]); }
      else if (k === SHOE_P) { s.shoes.push(v); s.order.push(['shoe', v]); }
      else if (COLOR_P && k === COLOR_P) { s.colors.push(v); s.order.push(['color', v]); }
      else if (k === 'filter.v.price.gte' || k === 'filter.v.price.lte') {
        if (s.price === null) {
          var g = parseFloat(u.searchParams.get('filter.v.price.gte') || '0');
          var idx = BUCKETS.findIndex(function (b) { return (b.lo || 0) === g; });
          if (idx >= 0) { s.price = idx; s.order.push(['price', idx]); }
        }
      }
    });
    return s;
  }
  var cur = readSel(here);
  function copySel(s) { return { size: s.size, brands: s.brands.slice(), shoes: s.shoes.slice(), colors: s.colors.slice(), price: s.price, order: s.order.slice() }; }
  function emptySel() { return { size: null, brands: [], shoes: [], colors: [], price: null, order: [] }; }
  function baseParams() {
    var p = new URLSearchParams();
    here.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') !== 0 && k !== 'page' && k !== 'section_id' && k !== 'sections' && k !== '_su_rec' && k !== '_su_rec_id') p.append(k, v); });
    /* מיון שנבחר ועוד לא חזר מהשרת: כל כתובת שנבנית בינתיים נושאת אותו */
    if (sortTarget) p.set('sort_by', sortTarget);
    return p;
  }
  function paramsFor(s, opts) {
    opts = opts || {};
    var p = baseParams();
    if (s.size && !opts.noSize) p.append(SIZE_P(s.size), s.size);
    s.brands.forEach(function (b) { p.append(VEND_P, b); });
    s.shoes.forEach(function (b) { p.append(SHOE_P, b); });
    if (COLOR_P) s.colors.forEach(function (b) { p.append(COLOR_P, b); });
    var pi = opts.price !== undefined ? opts.price : s.price;
    if (pi !== null && pi !== undefined) {
      var b = BUCKETS[pi];
      if (b.lo) p.append('filter.v.price.gte', b.lo);
      if (b.hi !== null) p.append('filter.v.price.lte', b.hi);
    }
    return p;
  }
  /* A2: הכתובת של הקולקציה יכולה להכיל query משלה (עמוד מותג: /collections/vendors?q=ZARA).
     בונים עם URL, ופרמטר שכבר קיים בכתובת הקולקציה (q) לא נוסף פעם שנייה */
  function buildUrl(p) {
    var u = new URL(data0.url, location.origin);
    var own = {};
    u.searchParams.forEach(function (v, k) { own[k] = 1; });
    if (p) p.forEach(function (v, k) { if (!own[k]) u.searchParams.append(k, v); });
    return u.pathname + u.search;
  }
  function urlFor(s) { return buildUrl(paramsFor(s)); }
  function selKey(s) { return JSON.stringify([s.brands, s.shoes, s.colors, s.price]); }
  /* אותה בחירה, בלי תלות בסדר הפרמטרים בכתובת (כתובת נחיתה ממודעה, utm באמצע) */
  function sameSel(a, b) {
    function k(s) { return JSON.stringify([s.size, s.brands.slice().sort(), s.shoes.slice().sort(), s.colors.slice().sort(), s.price]); }
    return k(a) === k(b);
  }
  function label(kind, v) {
    if (kind === 'size') return 'מידה ' + v;
    if (kind === 'shoe') return 'מידה ' + shoeLabel(v);
    if (kind === 'price') return bucketLabel(BUCKETS[v]) + ' ₪';
    if (kind === 'color') return colorName(v);
    return v;
  }
  function without(s, kind, v) {
    var n = copySel(s);
    if (kind === 'size') n.size = null;
    if (kind === 'brand') n.brands = n.brands.filter(function (x) { return x !== v; });
    if (kind === 'shoe') n.shoes = n.shoes.filter(function (x) { return x !== v; });
    if (kind === 'color') n.colors = n.colors.filter(function (x) { return x !== v; });
    if (kind === 'price') n.price = null;
    n.order = n.order.filter(function (o) { return !(o[0] === kind && String(o[1]) === String(v)); });
    return n;
  }
  function nSel(s) { return (s.size ? 1 : 0) + s.brands.length + s.shoes.length + s.colors.length + (s.price !== null ? 1 : 0); }
  function countTxt(n) { return n === 1 ? 'פריט אחד' : num(n) + ' פריטים'; }
  var xIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function chipsHtml(s, attr) {
    return s.order.map(function (o) {
      var t = label(o[0], o[1]);
      return '<button type="button" class="shc-act" ' + attr + '="' + esc(o[0] + '|' + o[1]) + '" aria-label="' + esc('הסרת ' + t) + '">' + ltr(esc(t), t) + ' ' + xIcon + '</button>';
    }).join('');
  }

  /* ===== פס עליון: צ'יפים פעילים, מונה, כפתור צבע, מיון ===== */
  var acts = root.querySelector('[data-shc-acts]');
  var nact = root.querySelector('[data-shc-nactive]');
  var sortSel = root.querySelector('[data-shc-sortsel]');
  var DOTS0 = '<i style="background:#1E1E1E"></i><i style="background:#C0392B"></i><i style="background:#2F5DA8"></i>';
  function paintColorBtn() {
    var b = root.querySelector('[data-shc-cbtn]');
    if (!b) return;
    var dots = b.querySelector('[data-shc-cdots]'), txt = b.querySelector('[data-shc-ctxt]');
    var n = cur.colors.length;
    b.classList.toggle('is-set', n > 0);
    if (!n) { dots.innerHTML = DOTS0; txt.textContent = 'צבע'; b.setAttribute('aria-label', 'סינון לפי צבע'); return; }
    dots.innerHTML = cur.colors.slice(0, n === 1 ? 1 : 2).map(function (k) { return '<i style="background:' + esc(swatch(colorObj(k)).bg) + '"></i>'; }).join('');
    if (n === 1) { txt.textContent = colorName(cur.colors[0]); b.setAttribute('aria-label', 'סינון לפי צבע: ' + colorName(cur.colors[0])); }
    else { txt.textContent = 'צבע (' + n + ')'; b.setAttribute('aria-label', 'סינון לפי צבע: ' + n + ' נבחרו'); }
  }
  function paintBar() {
    acts.innerHTML = chipsHtml(cur, 'data-shc-rm');
    var n = nSel(cur);
    nact.hidden = !n; nact.textContent = n ? n : '';
    /* המונה יושב ליד הכותרת, בסקשן של ראש העמוד (מחוץ ל-root) */
    var cnt = document.querySelectorAll('[data-shc-count]');
    for (var i = 0; i < cnt.length; i++) cnt[i].innerHTML = '<bdi>' + esc(countTxt(data0.count)) + '</bdi>';
    paintColorBtn();
  }
  acts.innerHTML = chipsHtml(cur, 'data-shc-rm');
  if (nSel(cur)) { nact.hidden = false; nact.textContent = nSel(cur); }
  paintColorBtn();
  if (sortSel) sortSel.addEventListener('change', function () {
    /* סינון שבדרך (target) נשמר: הכתובת נבנית ממנו ולא מהמצב הישן */
    sortTarget = sortSel.value;
    var u = new URL(target ? urlFor(target) : here.href, location.origin);
    u.searchParams.set('sort_by', sortTarget); u.searchParams.delete('page');
    navigate(u.pathname + u.search);
  });

  /* ===== שליפת מונים ===== */
  function fetchData(params) {
    var p = new URLSearchParams(params); p.delete('sections'); p.set('section_id', sectionId);
    return fetch(buildUrl(p), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return null;
        var m = t.match(/<script type="application\/json" data-shc-data>([\s\S]*?)<\/script>/);
        if (!m) return null;
        return parseData(m[1]);
      }).catch(function () { return null; });
  }

  /* כשמידה פעילה, המונים של שאר המידות בדף הם "וגם" עם המידה הפעילה. כדי לדעת אילו צ'יפים להראות צריך מונים בלי המידה.
     כשהמידה נבחרה מתוך העמוד המונים האלה כבר בידינו (baseSizes), ואין בקשה שנייה ואין קפיצה ברצועה. רק בנחיתה ישירה על כתובת עם מידה שולפים */
  var baseKey = null, baseSizes = null;
  function applyBase() {
    if (!cur.size || !baseSizes) return;
    var chips = root.querySelectorAll('.shc-qs [data-shc-size]');
    for (var i = 0; i < chips.length; i++) {
      var k = chips[i].getAttribute('data-shc-size');
      var x = baseSizes.find(function (s) { return s.k === k; });
      chips[i].hidden = !((x && x.n > 0) || k === cur.size);
    }
  }
  function syncSizeChips() {
    var key = selKey(cur);
    if (!cur.size) { baseKey = key; baseSizes = data0.sizes; return; }
    if (baseKey === key && baseSizes) { applyBase(); return; }
    var my = navSeq;
    fetchData(paramsFor(cur, { noSize: true })).then(function (d) {
      if (!d || my !== navSeq) return;
      baseKey = key; baseSizes = d.sizes; applyBase();
    });
  }

  /* ===== אין תוצאות: הסרת הפילטר האחרון בלבד (נ4) ===== */
  var rmLast = root.querySelector('[data-shc-removelast]');
  if (rmLast) {
    var last = cur.order[cur.order.length - 1];
    if (last) {
      rmLast.textContent = 'הסרת ' + label(last[0], last[1]);
      rmLast.href = urlFor(without(cur, last[0], last[1]));
    } else { rmLast.hidden = true; }
  }

  /* ===== פס דביק: צמוד להדר, בלי רווח ===== */
  var slot = root.querySelector('[data-shc-slot]');
  var bar = root.querySelector('[data-shc-bar]');
  var hdr = document.querySelector('.header_main_new');
  function placeBar() {
    var hb = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); hb = Math.max(0, r.bottom); }
    var h = bar.offsetHeight + 'px';
    if (slot.style.height !== h) slot.style.height = h;
    var fixed = slot.getBoundingClientRect().top < hb;
    bar.classList.toggle('is-fixed', fixed);
    bar.style.top = fixed ? hb + 'px' : '';
  }
  var settle = null;
  window.addEventListener('scroll', function () { placeBar(); clearTimeout(settle); settle = setTimeout(placeBar, 80); }, { passive: true });
  /* ההדר של התבנית הופך ל-fixed רק אחרי גלילה (body.sticky), במאזין משלו. מחשבים שוב כשהמחלקה משתנה */
  /* ההדר נכנס באנימציה (ופס ההודעה יכול להיעלם): עוקבים אחריו פריים-פריים כ-0.7 שניות, כדי שלא יישאר רווח בין ההדר לפס */
  var followUntil = 0, following = false;
  function followHeader() {
    followUntil = Date.now() + 700;
    if (following) return;
    following = true;
    (function tick() { placeBar(); if (Date.now() < followUntil) { requestAnimationFrame(tick); } else { following = false; } })();
  }
  new MutationObserver(followHeader).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (hdr && window.ResizeObserver) { new ResizeObserver(followHeader).observe(hdr); }
  window.addEventListener('resize', followHeader);
  /* שחזור הגלילה בחזרה לקטגוריה קורה לפני/בלי אירוע גלילה שלנו: מחשבים שוב אחרי הטעינה */
  window.addEventListener('load', placeBar);
  setTimeout(placeBar, 500); setTimeout(placeBar, 1500); setTimeout(placeBar, 3000);
  placeBar();

  /* ===== כפתור הסל בכרטיס (אייקון בתוך התמונה): שם נגיש עם שם הפריט ===== */
  var gridEl = document.querySelector('.productListing');
  function labelAtc() {
    if (!gridEl) return;
    gridEl.querySelectorAll('.card-information [data-btn-addtocart]').forEach(function (b) {
      /* fix-pack-9 סבב 2: כרטיס "נמכר" (data-shani-sold, snippets/shani-early-atc) מנוהל שם */
      if (b.hasAttribute('data-shani-sold')) return;
      var card = b.closest('.card'); var t = card && card.querySelector('[data-product-title]');
      /* בזמן ההוספה (theme.js שם is-loading מהלחיצה ועד תשובת הסל): "מוסיפה לסל" + aria-busy (בקשת הבונה "card") */
      var busy = b.classList.contains('is-loading') && !b.classList.contains('shg-incart');
      /* fix-pack-9 (רן P1-1): "לצפייה בסל: שם", אותו שם של snippets/shani-early-atc. בלי ההוספה השקטה (__shaniQuietCard כבוי): "בסל: שם" כמו קודם */
      var lbl = (b.classList.contains('shg-incart') ? (window.__shaniQuietCard ? 'לצפייה בסל: ' : 'בסל: ') : (busy ? 'מוסיפה לסל: ' : 'הוסיפי לסל: ')) + (t ? t.getAttribute('data-product-title').trim() : '');
      if (b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
      if (busy) { if (b.getAttribute('aria-busy') !== 'true') b.setAttribute('aria-busy', 'true'); }
      else if (b.hasAttribute('aria-busy')) b.removeAttribute('aria-busy');
    });
  }
  /* המשקיף רץ על כל שינוי מחלקה ברשת (כל תמונה שנטענת). מאחדים לריצה אחת בפריים, כדי לא להעמיס בזמן שהלקוחה לוחצת */
  var atcQueued = false;
  function queueAtc() {
    if (atcQueued) return;
    atcQueued = true;
    requestAnimationFrame(function () { atcQueued = false; unmarkGone(); labelAtc(); });
  }
  /* ===== מצב "בסל" מול הסל האמיתי =====
     theme.js שולח cart-update (עם הסל) אחרי כל הוספה, הסרה ועדכון של מגירת הסל. shani-cart-guard מסמן "בסל" רק 2.5 שניות אחרי הלחיצה
     ואף פעם לא מוריד את הסימון. כאן: מסמנים מיד כשהסל מאשר, ומורידים כשהפריט כבר לא בסל (cartGone), גם אם השומר סימן שוב. */
  var cartEver = {}, cartGone = {}, lastAtc = null;
  function vidOf(b) { var f = b.closest('form'); var i = f && f.querySelector('input[name="id"]'); return i && i.value ? String(i.value) : ''; }
  function atcBtns() { return gridEl ? gridEl.querySelectorAll('.card-information [data-btn-addtocart]') : []; }
  function unmarkGone() {
    [].forEach.call(atcBtns(), function (b) {
      if (!b.classList.contains('shg-incart') || !cartGone[vidOf(b)]) return;
      b.classList.remove('shg-incart'); b.disabled = false; b.removeAttribute('aria-disabled');
    });
  }
  document.addEventListener('cart-update', function (e) {
    var c = e && e.detail;
    if (!gridEl || !c || !c.items || !c.items.forEach) return;
    var ids = {}, k;
    c.items.forEach(function (it) { ids[String(it.variant_id)] = 1; cartEver[String(it.variant_id)] = 1; });
    [].forEach.call(atcBtns(), function (b) {
      var v = vidOf(b);
      if (!v) return;
      if (b.classList.contains('shg-incart')) cartEver[v] = 1;
      else if (ids[v] && b.tagName === 'BUTTON') { b.classList.add('shg-incart'); b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.textContent = 'בסל'; }
    });
    cartGone = {};
    for (k in cartEver) if (!ids[k]) cartGone[k] = 1;
    unmarkGone();
    labelAtc();
    /* הודעה לקוראת מסך אחרי הוספה מהכרטיס */
    /* fix-pack-9: כשהפס של snippets/shani-early-atc דלוק (__shaniCardBar), ההכרזה "הפריט נוסף לסל" יוצאת משם בלבד. כאן לא מכריזים שוב */
    if (lastAtc && window.__shaniCardBar) lastAtc = null;
    if (lastAtc && ids[lastAtc.v] && Date.now() - lastAtc.t < 20000 && liveEl) {
      var msg = 'בסל: ' + lastAtc.n; lastAtc = null;
      liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 60);
    }
  });
  if (gridEl) gridEl.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.card-information [data-btn-addtocart]');
    if (!b || b.classList.contains('shg-incart')) return;
    var card = b.closest('.card'), t = card && card.querySelector('[data-product-title]');
    lastAtc = { v: vidOf(b), n: t ? t.getAttribute('data-product-title').trim() : '', t: Date.now() };
    /* fix2: נעול מהלחיצה ועד "בסל" (היה חלון של 370ms). לחיצה שנייה כבר נעצרת בשומר הסל ל-3 שניות; כאן רק ההצהרה הנגישה. הוספה שנכשלה: משתחרר */
    b.setAttribute('aria-disabled', 'true');
    setTimeout(function () { if (!b.classList.contains('shg-incart') && !b.hasAttribute('data-shani-sold')) b.removeAttribute('aria-disabled'); }, 3000);
  });
  if (gridEl) { labelAtc(); new MutationObserver(function () { queueAtc(); }).observe(gridEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }

  /* ===== A4: הטעינה האוטומטית של התבנית =====
     theme.js טוען את האצווה הבאה בכל אירוע גלילה שבו המסך עבר את "500px לפני אזור העימוד", גם כשהאזור כבר מעל המסך.
     לכן גלילה קטנה בפוטר טענה אצווה אחרי אצווה. התבנית מדלגת כשעל הקישור יש is-loading: כשאזור העימוד כבר מעל המסך
     אנחנו מסמנים אותו כך (עם data-shc-hold, כדי לא להתבלבל עם טעינה אמיתית), ומשחררים כשהוא חוזר למסך.
     מאזין בשלב capture על window רץ לפני המאזין של התבנית (bubble), בלי תלות בסדר הטעינה. theme.js לא נערך. */
  function infLink() { return document.querySelector('.pagination-infinite [data-infinite-scrolling]'); }
  function gateAuto() {
    /* בזמן החלפת רשת האחיזה נשארת (navigate שם אותה), גם כשאזור העימוד במסך */
    if (document.documentElement.classList.contains('shc-loading')) return;
    var l = infLink();
    if (!l) return;
    var box = l.closest('.pagination') || l;
    var passed = box.getBoundingClientRect().bottom < 60;
    if (passed) {
      if (!l.classList.contains('is-loading')) { l.classList.add('is-loading'); l.setAttribute('data-shc-hold', ''); }
    } else if (l.hasAttribute('data-shc-hold')) {
      l.removeAttribute('data-shc-hold'); l.classList.remove('is-loading');
    }
  }
  window.addEventListener('scroll', gateAuto, { capture: true, passive: true });
  window.addEventListener('load', gateAuto, true);

  /* ===== fix-pack-4: מי שדילגה מעבר ל"הצגת עוד" =====
     האחיזה למעלה עוצרת את הטעינה כשאזור העימוד כבר מעל המסך. מי שהגיעה לשם בקפיצה (החלקה מהירה, גרירת פס הגלילה, End,
     או אצווה שנוספה מעליה) נשארה מול הפוטר, והעמוד הבא לא התבקש אף פעם.
     כאן: כשהגלילה נחה (CATCH_REST בלי אירוע גלילה) והקישור עדיין באחיזה מעל המסך, משחררים אותו ומפעילים פעם אחת את הלחיצה של התבנית עליו.
     אצווה אחת לכל מנוחה, ולא יותר מאחת ב-CATCH_GAP. בזמן גלילה רציפה לא נשלח דבר, כמו קודם.
     בקשה שנכשלה נשארת נעולה ב-is-loading בלי אחיזה עד MORE_MAX (fix-d), ולכן אין כאן ניסיון חוזר בכל מנוחה.
     בזמן האצווה הזו עיגון הגלילה של הדפדפן כבוי (overflow-anchor), כדי שהכרטיסים החדשים ייכנסו למסך ולא יידחפו אל מעליו. */
  var CATCH_REST = 180, CATCH_GAP = 1200, catchT = null, catchAt = 0, catching = false;
  function catchUp() {
    catchT = null;
    if (document.documentElement.classList.contains('shc-loading')) return;
    var l = infLink();
    if (!l || !l.hasAttribute('data-shc-hold') || Date.now() - catchAt < CATCH_GAP) return;
    var box = l.closest('.pagination') || l;
    if (box.getBoundingClientRect().bottom >= 60) return;
    catchAt = Date.now();
    l.removeAttribute('data-shc-hold'); l.classList.remove('is-loading');
    var se = document.scrollingElement || document.documentElement, prev = se.style.overflowAnchor, n = 0;
    se.style.overflowAnchor = 'none';
    var iv = setInterval(function () {
      if (infLink() === l && l.classList.contains('is-loading') && ++n < 150) return;
      clearInterval(iv);
      setTimeout(function () { se.style.overflowAnchor = prev; }, 120);
    }, 100);
    /* המטפל של התבנית על הקישור (theme.js 5189). אם הוא עוד לא רשום, הלחיצה לא מנווטת ל-href: המאזין שבסוף הבלוק עוצר אותה */
    catching = true;
    try { l.click(); } finally { catching = false; }
  }
  function catchQueue() { clearTimeout(catchT); catchT = setTimeout(catchUp, CATCH_REST); }
  window.addEventListener('scroll', catchQueue, { capture: true, passive: true });
  window.addEventListener('click', function (e) { if (catching && !e.defaultPrevented) e.preventDefault(); });

  /* ===== fix-b: נעילה אחת ל"הצגת עוד", ובלי כרטיס כפול =====
     theme.js: הטעינה בגלילה מדלגת כשעל הקישור יש is-loading (שורה 5177). המאזין של הלחיצה (5189-5196) לא בודק,
     ולכן לחיצה בזמן שאצווה כבר בדרך שלחה את אותו page פעם שנייה, ושתי התשובות נוספו לרשת.
     is-loading על הקישור הוא הנעילה המשותפת לשני המפעילים: כאן הלחיצה נעצרת כשהוא דלוק
     (capture על window, רץ לפני המאזין של התבנית על document). theme.js לא נערך.
     שחרור: התבנית מורידה is-loading ב-complete. בקשה שנכשלה: הלחיצה משתחררת מיד (moreFailHook). בקשה שתלויה בלי תשובה: אחרי MORE_MAX.
     הגנה שנייה: כרטיס שהמזהה שלו כבר ברשת מוסר מיד אחרי שנוסף, והמונה מתיישר למספר הכרטיסים הייחודיים. */
  var MORE_MAX = 15000, moreT = null, moreEl = null, moreQ = null;
  function moreWatch() {
    moreQ = null;
    var l = infLink();
    var on = !!l && l.classList.contains('is-loading') && !l.hasAttribute('data-shc-hold');
    if (!on) { clearTimeout(moreT); moreT = null; moreEl = null; return; }
    if (moreEl === l && moreT) return;
    clearTimeout(moreT); moreEl = l;
    moreT = setTimeout(function () {
      moreT = null; moreEl = null;
      if (infLink() !== l) return;
      l.removeAttribute('data-shc-fail');
      if (l.classList.contains('is-loading') && !l.hasAttribute('data-shc-hold')) { l.classList.remove('is-loading'); gateAuto(); }
    }, MORE_MAX);
  }
  /* בקשה שנכשלה (שגיאת רשת או שרת): התבנית לא מגיעה ל-complete, ו-is-loading נשאר. מסמנים data-shc-fail ומחזירים את נוסח הכפתור,
     והלחיצה הבאה עוברת מיד. is-loading נשאר עד MORE_MAX, כדי שהגלילה לא תשלח בקשה חוזרת בכל אירוע גלילה.
     ajaxPrefilter רץ לפני שהתבנית מחברת את ה-error שלה, ולכן המאזין הזה רץ ראשון. */
  function moreFailHook() {
    var jq = window.jQuery;
    if (!jq || !jq.ajaxPrefilter || moreFailHook.on) return;
    moreFailHook.on = true;
    jq.ajaxPrefilter(function (o, orig, xhr) {
      var l = infLink();
      if (!l || !o || o.url !== l.getAttribute('href')) return;
      xhr.fail(function () {
        if (infLink() !== l || !l.classList.contains('is-loading') || l.hasAttribute('data-shc-hold')) return;
        l.setAttribute('data-shc-fail', '');
        var t = l.getAttribute('data-load-more');
        if (t) l.textContent = t;
      });
    });
  }
  moreFailHook();
  window.addEventListener('load', moreFailHook);
  /* אחרי המאזין של התבנית (setTimeout 0): רק אז רואים אם היא התחילה אצווה */
  function moreQueue() { if (!moreQ) moreQ = setTimeout(moreWatch, 0); }
  window.addEventListener('scroll', moreQueue, { capture: true, passive: true });
  window.addEventListener('load', moreQueue, true);
  window.addEventListener('click', function (e) {
    var l = e.target && e.target.closest ? e.target.closest('[data-infinite-scrolling]') : null;
    if (!l) return;
    /* הבקשה הקודמת נכשלה: הלחיצה עוברת לתבנית, והשעון מתחיל מחדש */
    if (l.hasAttribute('data-shc-fail')) { l.removeAttribute('data-shc-fail'); clearTimeout(moreT); moreT = null; moreEl = null; moreQueue(); return; }
    /* אצווה בדרך (של הגלילה, של לחיצה קודמת, של שחזור המיקום) או החלפת רשת: הלחיצה לא שולחת בקשה נוספת, וגם לא מנווטת ל-href */
    if (l.classList.contains('is-loading')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    moreQueue();
  }, true);

  function cardKey(li) {
    var c = li.querySelector('[data-product-id]'), k = c && c.getAttribute('data-product-id');
    if (k) return 'i' + k;
    c = li.querySelector('[data-product-handle]'); k = c && c.getAttribute('data-product-handle');
    return k ? 'h' + k : null;
  }
  function dedupeCards() {
    var ul = listEl();
    if (!ul) return;
    var seen = {}, rm = [], kids = ul.children, i, k, n = 0;
    for (i = 0; i < kids.length; i++) {
      if (!kids[i].matches || !kids[i].matches('li.product')) continue;
      k = cardKey(kids[i]);
      if (k && seen[k]) { rm.push(kids[i]); continue; }
      if (k) seen[k] = 1;
      n++;
    }
    if (!rm.length) return;
    for (i = 0; i < rm.length; i++) ul.removeChild(rm[i]);
    /* המונה: רק בעמוד שנפתח מההתחלה (עמוד שנפתח ישר על ?page=N לא מתחיל ב-1) */
    var pg = /[?&]page=(\d+)/.exec(location.search);
    if (pg && parseInt(pg[1], 10) > 1) return;
    var txt = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var ends = document.querySelectorAll('#CollectionProductGrid [data-total-end]');
    for (i = 0; i < ends.length; i++) if (ends[i].textContent !== txt) ends[i].textContent = txt;
  }
  if (listEl() && window.MutationObserver) new MutationObserver(dedupeCards).observe(listEl(), { childList: true });

  /* ===== C1: החלפת הרשת במקום ===== */
  var htmlEl = document.documentElement;
  var prog = root.querySelector('[data-shc-prog]');
  var liveEl = root.querySelector('[data-shc-live]');
  var gridSecId = (function () { var g = document.getElementById('main-collection-product-grid'); return g ? g.getAttribute('data-id') : null; })();
  var navSeq = 0, navCtrl = null, progT = null, failT = null;
  var target = null;   /* הבחירה שבדרך (לחיצה שעוד לא חזרה מהשרת). לחיצה נוספת מחושבת ממנה, לא מהמצב הישן */
  function listEl() { return document.querySelector('ul#main-collection-product-grid.productListing'); }
  function setBusy(on) {
    clearTimeout(progT); clearTimeout(failT);
    htmlEl.classList.toggle('shc-loading', !!on);
    var g = document.getElementById('CollectionProductGrid');
    if (g) { if (on) g.setAttribute('aria-busy', 'true'); else g.removeAttribute('aria-busy'); }
    if (prog) prog.hidden = true;
    /* קו ההתקדמות מופיע רק אם התשובה מתעכבת יותר מ-300ms */
    if (on && prog) progT = setTimeout(function () { prog.hidden = false; }, 300);
  }
  /* נפילה לניווט מלא. המסך נשאר מעומעם עד שהעמוד מתחלף (המשוב המיידי נשמר). חזרה מ-bfcache מנקה את העמעום (pageshow) */
  /* אם גם הניווט המלא לא התבצע (הרשת נפלה, הלקוחה עצרה את הטעינה): אחרי 8 שניות משחררים את העמעום ומחזירים את הסרגל למצב האמיתי */
  function hardGo(url, pop) {
    var my = navSeq;
    setTimeout(function () {
      if (my !== navSeq) return;
      target = null; sortTarget = null;
      setBusy(false);
      paintChips(cur);
      if (sortSel) { var sv = here.searchParams.get('sort_by'); if (sv && sortSel.value !== sv) sortSel.value = sv; }
      gateAuto();
    }, 8000);
    if (pop) location.reload(); else location.href = url;
  }
  function sectionsUrl(u) {
    var s = new URL(u.href);
    s.searchParams.delete('section_id'); s.searchParams.set('sections', sectionId + ',' + gridSecId); s.hash = '';
    return s.pathname + s.search;
  }
  /* צביעה מיידית של הרצועה לפי בחירה (לפני כל בקשת רשת) */
  function paintChips(sel) {
    var a = root.querySelectorAll('.shc-qs [data-shc-size]'), i, on;
    for (i = 0; i < a.length; i++) {
      on = a[i].getAttribute('data-shc-size') === sel.size;
      a[i].classList.toggle('is-on', on); a[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    a = root.querySelectorAll('.shc-qs [data-shc-qshoe]');
    for (i = 0; i < a.length; i++) {
      on = sel.shoes.indexOf(a[i].getAttribute('data-shc-qshoe')) >= 0;
      a[i].classList.toggle('is-on', on); a[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  function centerChip() {
    var qs = root.querySelector('[data-shc-qs]'); var c = qs && qs.querySelector('.shc-qchip.is-on');
    if (!c) return;
    var a = qs.getBoundingClientRect(), b = c.getBoundingClientRect();
    if (b.left < a.left || b.right > a.right) qs.scrollLeft += (b.left + b.width / 2) - (a.left + a.width / 2);
  }
  /* אם ראש הרשת נמצא מעל הפס הדביק (הלקוחה גללה לתוך הרשת), מביאים את השורה הראשונה אל מתחת לפס */
  function revealGrid() {
    var l = listEl();
    if (!l || !bar.classList.contains('is-fixed')) return;
    var barB = bar.getBoundingClientRect().bottom, top = l.getBoundingClientRect().top;
    if (top < barB) window.scrollTo(0, Math.max(0, window.pageYOffset + top - barB - 8));
  }
  function announce() {
    if (!liveEl) return;
    var t = data0.count === 0 ? 'כרגע אין פריטים בבחירה הזו' : countTxt(data0.count);
    if (data0.count > 0) {
      if (cur.size) t += ' במידה ' + cur.size;
      else if (cur.shoes.length === 1) t += ' במידה ' + shoeLabel(cur.shoes[0]);
    }
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = t; }, 60);
  }
  /* מחליף את הרשת, את העימוד ואת הרצועה מתוך תשובת ה-sections. מחזיר false אם משהו חסר, ואז נופלים לניווט מלא */
  function swap(j, u) {
    var fHtml = j && j[sectionId], gHtml = j && j[gridSecId];
    if (typeof fHtml !== 'string' || typeof gHtml !== 'string') return false;
    var fDoc = new DOMParser().parseFromString(fHtml, 'text/html');
    var gDoc = new DOMParser().parseFromString(gHtml, 'text/html');
    var dEl = fDoc.querySelector('[data-shc-data]');
    var newList = gDoc.querySelector('ul#main-collection-product-grid.productListing');
    var curList = listEl();
    /* "אין פריטים": התבנית מרנדרת מבנה אחר בלי <ul>. שם ניווט מלא (ההודעה הריקה שלנו מרונדרת בשרת) */
    if (!dEl || !newList || !curList) return false;
    var d;
    try { d = parseData(dEl.textContent); } catch (e) { return false; }
    if (!d.count) return false;
    if (!d.color && data0.color) d.color = { p: data0.color.p, values: [] };

    /* הרשת: אותו <ul>, <li> חדשים. רק אלמנטים (המשקיף של התבנית קורא querySelector על כל צומת שנוסף) */
    var frag = document.createDocumentFragment(), kids = newList.children, i;
    for (i = 0; i < kids.length; i++) frag.appendChild(document.importNode(kids[i], true));
    while (curList.firstChild) curList.removeChild(curList.firstChild);
    curList.appendChild(frag);

    /* העימוד (מונה "פריטים 1–50 מתוך N" + "הצגת עוד"): מוחלף, נוסף או יורד */
    var box = curList.parentNode;
    var curPg = box.querySelector('.pagination-wrapper'), newPg = gDoc.querySelector('.pagination-wrapper');
    if (newPg && !document.querySelector('link[href*="component-pagination"]')) {
      var css = gDoc.querySelector('link[href*="component-pagination"]');
      if (css) document.head.appendChild(document.importNode(css, true));
    }
    if (curPg && newPg) box.replaceChild(document.importNode(newPg, true), curPg);
    else if (curPg) box.removeChild(curPg);
    else if (newPg) box.appendChild(document.importNode(newPg, true));

    /* הרצועה: ה-HTML של השרת (כתובות אמיתיות ומצב נבחר). הפוקוס חוזר לאותו צ'יפ */
    var newQs = fDoc.querySelector('[data-shc-qs]'), curQs = root.querySelector('[data-shc-qs]');
    if (newQs && curQs) {
      var ae = document.activeElement, fk = null;
      if (ae && curQs.contains(ae)) fk = ae.hasAttribute('data-shc-size') ? ['data-shc-size', ae.getAttribute('data-shc-size')] : (ae.hasAttribute('data-shc-qshoe') ? ['data-shc-qshoe', ae.getAttribute('data-shc-qshoe')] : null);
      var sl = curQs.scrollLeft;
      curQs.innerHTML = newQs.innerHTML;
      curQs.scrollLeft = sl;
      if (fk) {
        var again = [].slice.call(curQs.querySelectorAll('[' + fk[0] + ']')).find(function (x) { return x.getAttribute(fk[0]) === fk[1]; });
        if (again && !again.hidden) { try { again.focus({ preventScroll: true }); } catch (e2) { again.focus(); } }
      }
    }
    var newSort = fDoc.querySelector('[data-shc-sortsel]');
    if (newSort && sortSel && sortSel.value !== newSort.value) sortSel.value = newSort.value;

    data0 = d;
    here = new URL(u.href);
    cur = readSel(here);
    target = null; sortTarget = null;
    pend = copySel(cur);
    live = { total: data0.count, sizes: data0.sizes, vendors: data0.vendors, shoes: data0.shoes, colors: data0.color ? data0.color.values : [], prices: null };
    return true;
  }
  function afterSwap(opts) {
    paintBar();
    paintChips(cur);
    syncSizeChips();
    /* מה שהתבנית עושה אחרי שהיא מוסיפה כרטיסים בעצמה (theme.js, ajaxInfiniteScrollingMapData): מסמנת לבבות שמורים */
    try {
      if (window.wishlist && window.wishlist.show && window.sharedFunctions && window.sharedFunctions.setLocalStorageProductForWishlist) {
        window.sharedFunctions.setLocalStorageProductForWishlist();
      }
    } catch (e) {}
    try {
      if (window.sharedFunctions && window.sharedFunctions.checkNeedToConvertCurrency && window.sharedFunctions.checkNeedToConvertCurrency() && window.Currency) {
        var active = document.querySelector('#currencies .active');
        if (active) window.Currency.convertAll(window.shop_currency, active.getAttribute('data-currency'), 'span.money', 'money_format');
      }
    } catch (e1) {}
    labelAtc();
    centerChip();
    if (!opts.pop) revealGrid();
    /* חזרה/קדימה: למקום שבו עמדה כשיצאה מהמצב הזה (למשל מול רצועת המותגים). הרשת כבר הוחלפה, הגבהים שמורים.
       fix2: הרשת חוזרת תמיד עם עמוד 1 בלבד. אם כשיצאה היו בה יותר כרטיסים (נטענו אצוות בגלילה) והגובה השמור נופל מתחת לסוף הרשת של עכשיו
       (אותו סף של collection-scroll-restore.js, 40px), הגובה הזה כבר לא קיים: הולכים לראש הרשת ולא לפוטר. אותו מספר כרטיסים: הגובה המדויק, כמו קודם */
    else if (typeof opts.y === 'number') {
      try {
        var gl = listEl(), gr = gl ? gl.getBoundingClientRect() : null, sy = window.pageYOffset || 0;
        /* ראש הרשת: השורה הראשונה מתחת להדר הדביק ולפס הסינון (גובה ההדר נקרא מהאלמנט, עם תקרה: בשנייה הראשונה של הטעינה הוא גבוה פי כמה) */
        /* 23.10.2026: במחשב חלק מההדר יוצא מהמסך במצב דביק (shani-header-compact). shaniHdrShift מחזיר כמה, כדי שהשורה לא תנחת נמוך מדי */
        if (gr && typeof opts.n === 'number' && gl.children.length < opts.n && opts.y >= gr.bottom + sy - 40) window.scrollTo(0, Math.max(0, gr.top + sy - (Math.min(240, hdr ? hdr.offsetHeight - (window.shaniHdrShift ? window.shaniHdrShift() : 0) : 0) + bar.offsetHeight + 8)));
        else window.scrollTo(0, opts.y);
      } catch (e5) {}
    }
    placeBar();
    gateAuto();
    announce();
    /* B2: הצ'יפ שנלחץ ברצועת המותגים כבר לא בדף (עם מסנן מותג הרצועה לא מודפסת). הפוקוס עובר לצ'יפ הפעיל של המותג בסרגל */
    if (stripNav === navSeq) {
      var sf = acts.lastElementChild;
      if (sf && (!document.activeElement || document.activeElement === document.body)) { try { sf.focus({ preventScroll: true }); } catch (e3) { sf.focus(); } }
    }
    stripNav = 0;
  }
  function navigate(url, opts) {
    opts = opts || {};
    var u = new URL(url, location.href);
    var abs = u.pathname + u.search;
    var my = ++navSeq;
    /* fix1 מותגים: איפה הלקוחה עמדה כשיצאה מהמצב הזה. נשמר ברשומת ההיסטוריה שלו רגע לפני pushState, ו"חזרה" מחזירה אותה לשם (popstate) */
    var y0 = window.pageYOffset || 0, gl0 = listEl(), n0 = gl0 ? gl0.children.length : 0;
    if (navCtrl) { try { navCtrl.abort(); } catch (e) {} navCtrl = null; }
    setBusy(true);
    if (!window.fetch || !window.DOMParser || !history.pushState || !gridSecId || !listEl()) { hardGo(abs, opts.pop); return; }
    popSeq = opts.pop ? my : 0;
    /* הטעינה בגלילה של התבנית (theme.js) מוסיפה כרטיסים ומחליפה את העימוד כשהתשובה שלה חוזרת.
       אצווה שלה כבר בדרך: היא הייתה נוחתת ברשת המסוננת, ולכן ניווט מלא. אחרת: אחיזה על הקישור עד שהעימוד מוחלף ב-swap */
    var il = infLink();
    if (il && il.classList.contains('is-loading') && !il.hasAttribute('data-shc-hold')) { navSeq++; hardGo(abs, opts.pop); return; }
    if (il) { il.classList.add('is-loading'); il.setAttribute('data-shc-hold', ''); }
    navCtrl = window.AbortController ? new AbortController() : null;
    var ctrl = navCtrl;
    /* 6 שניות בלי תשובה: ניווט מלא. לא נשארים במצב מעומעם */
    failT = setTimeout(function () {
      if (my !== navSeq) return;
      navSeq++;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      hardGo(abs, opts.pop);
    }, 6000);
    /* בלי כותרת Accept: עם application/json שופיפיי עונה לכתובת של קולקציה ב-JSON של הקולקציה, לא בסקשנים */
    var fo = { credentials: 'same-origin' };
    if (ctrl) fo.signal = ctrl.signal;
    fetch(sectionsUrl(u), fo)
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        if (my !== navSeq) return;
        if (!swap(j, u)) throw new Error('swap');
        popSeq = 0;
        if (!opts.pop) {
          try { var st0 = history.state; history.replaceState(Object.assign({}, st0 && typeof st0 === 'object' ? st0 : {}, { shcY: y0, shcN: n0 }), ''); } catch (e4) {}
          try { history.pushState({ shc: 1 }, '', abs); } catch (e) {}
        }
        setBusy(false);
        afterSwap(opts);
      })
      .catch(function () {
        /* בקשה שבוטלה ע"י לחיצה חדשה יותר (או שכבר נפלנו לניווט מלא): לא עושים כלום */
        if (my !== navSeq) return;
        navSeq++;
        clearTimeout(failT);
        hardGo(abs, opts.pop);
      });
  }
  function choose(sel) {
    var url = urlFor(sel);
    /* אותה כתובת שכבר מוצגת (למשל "הצגת N פריטים" בלי שינוי): לא מוסיפים רשומה להיסטוריה */
    if (!target && !sortTarget && (url === here.pathname + here.search || sameSel(sel, cur))) { paintChips(cur); return; }
    target = sel; paintChips(sel); navigate(url);
  }
  function plainClick(e) { return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button); }

  /* ===== B2: רצועת "קנייה לפי מותג" בתוך הרשת (snippets/shani-brand-strip) =====
     הצ'יפ הוא קישור אמיתי (url_to_add מהשרת, עובד גם בלי הסקריפט). כאן מיירטים: המותג מתווסף לבחירה הנוכחית והרשת מוחלפת במקום,
     באותו מסלול של המגירה (choose). הרצועה יושבת ברשת, מחוץ ל-root, ולכן המאזין על document. "כל המותגים" (בלי data-shb-chip): ניווט רגיל */
  var stripNav = 0, popSeq = 0;   /* popSeq: המספר של בקשת "חזרה/קדימה" שעוד בדרך (0 = אין) */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.shc-bstrip [data-shb-chip]');
    if (!t || e.defaultPrevented || !plainClick(e)) return;
    /* הערך המדויק של המסנן נקרא מהכתובת שהשרת בנה (לא מהשם המוצג) */
    var v = null, base = target || cur;
    try { new URL(t.href, location.href).searchParams.getAll(VEND_P).forEach(function (x) { if (base.brands.indexOf(x) < 0) v = x; }); } catch (e0) {}
    if (!v) return;
    e.preventDefault();
    var n = copySel(base); n.brands.push(v); n.order.push(['brand', v]);
    var before = navSeq;
    choose(n);
    stripNav = navSeq !== before ? navSeq : 0;
  });

  /* חזרה/קדימה בדפדפן בין מצבי סינון: אותו מסמך, ולכן popstate ולא טעינה. מחליפים את הרשת למצב של הכתובת */
  window.addEventListener('popstate', function () {
    var now = urlNow();
    if (now.pathname === here.pathname && now.search === here.search) {
      /* fix2: "חזרה" ומיד "קדימה" (או להפך). הכתובת חזרה למצב שכבר מוצג, אבל בקשת ה"חזרה" עוד בדרך, והיעד שלה כבר אינו הכתובת.
         זורקים אותה (אחרת הרשת שלה נוחתת תחת כתובת של מצב אחר) ומשחררים את העמעום. בלי בקשה כזו: שינוי hash בלבד, לא עושים כלום */
      if (popSeq && popSeq === navSeq) {
        navSeq++; popSeq = 0;
        if (navCtrl) { try { navCtrl.abort(); } catch (e6) {} navCtrl = null; }
        target = null; sortTarget = null;
        setBusy(false); paintChips(cur); gateAuto();
      }
      return;
    }
    if (now.pathname !== here.pathname) { location.reload(); return; }
    if (sheet && !sheet.hidden) closeSheet();
    target = null; sortTarget = null;
    paintChips(readSel(now));
    var stp = history.state;
    navigate(now.pathname + now.search, { pop: true, y: stp && typeof stp.shcY === 'number' ? stp.shcY : null, n: stp && typeof stp.shcN === 'number' ? stp.shcN : null });
  });
  /* חזרה לעמוד מה-bfcache אחרי ניווט מלא: מנקים עמעום שנשאר, ומחזירים את הרצועה למצב האמיתי */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) { navSeq++; target = null; sortTarget = null; setBusy(false); paintChips(cur); gateAuto(); }
    placeBar();
  });
  syncSizeChips();

  /* ===== המגירה ===== */
  var sheet = root.querySelector('[data-shc-sheet]');
  var scrim = root.querySelector('.shc-scrim');
  var main = root.querySelector('[data-shc-main]');
  var brandsView = root.querySelector('[data-shc-brands]');
  var backBtn = root.querySelector('[data-shc-back]');
  var titleEl = root.querySelector('[data-shc-title]');
  var pendRow = root.querySelector('[data-shc-pend]');
  var applyBtn = root.querySelector('[data-shc-apply]');
  var bsearch = root.querySelector('[data-shc-bsearch]');
  var colorBox = root.querySelector('[data-shc-colors]');
  var colorSec = root.querySelector('[data-shc-color-sec]');
  var pend = copySel(cur);
  var live = { total: data0.count, sizes: data0.sizes, vendors: data0.vendors, shoes: data0.shoes, colors: data0.color ? data0.color.values : [], prices: null };
  var seq = 0, timer = null, opener = null, liveKey = null;

  function refresh() {
    clearTimeout(timer);
    applyBtn.disabled = true;
    sheet.classList.add('is-loading');
    liveKey = null;
    timer = setTimeout(function () {
      var my = ++seq, key = selKey(pend);
      var jobs = [fetchData(paramsFor(pend)), fetchData(paramsFor(pend, { noSize: true }))]
        .concat(BUCKETS.map(function (b, i) { return fetchData(paramsFor(pend, { price: i })); }));
      Promise.all(jobs).then(function (res) {
        if (my !== seq) return;
        var d = res[0], ds = res[1];
        if (d) { live.total = d.count; live.vendors = d.vendors; live.shoes = d.shoes; if (d.color) live.colors = d.color.values; }
        if (ds) { live.sizes = ds.sizes; liveKey = key; }
        live.prices = res.slice(2).map(function (x) { return x ? x.count : null; });
        sheet.classList.remove('is-loading');
        render();
      });
    }, 200);
  }
  function render() {
    if (nSel(pend)) {
      pendRow.hidden = false;
      pendRow.innerHTML = chipsHtml(pend, 'data-shc-prm') + '<button type="button" class="shc-clr" data-shc-clear>ניקוי הכל</button>';
    } else { pendRow.hidden = true; pendRow.textContent = ''; }
    root.querySelector('[data-shc-sizes]').innerHTML = SIZE_ORDER.map(function (k) {
      var x = (live.sizes || []).find(function (s) { return s.k === k; });
      var n = x ? x.n : 0, on = pend.size === k;
      return '<button type="button" class="shc-chip' + (on ? ' is-on' : '') + '" data-shc-psize="' + k + '" aria-pressed="' + on + '"' + (n === 0 && !on ? ' disabled' : '') + '>' + k + '<small>' + num(n) + '</small></button>';
    }).join('');
    /* קולקציית נעליים: במגירה רק מידות נעליים. אחרת: בגדים, ונעליים כקבוצה נוספת כשיש */
    root.querySelector('[data-shc-sizes]').hidden = shoeCol;
    root.querySelector('.shc-grp--sub').hidden = shoeCol;
    var shoesWrap = root.querySelector('[data-shc-shoes-wrap]');
    var shoes = (live.shoes || []).filter(function (s) { return s.n > 0 || pend.shoes.indexOf(s.k) >= 0; });
    shoesWrap.hidden = !shoes.length;
    root.querySelector('[data-shc-shoes]').innerHTML = shoes.map(function (s) {
      var on = pend.shoes.indexOf(s.k) >= 0;
      return '<button type="button" class="shc-chip' + (on ? ' is-on' : '') + '" data-shc-pshoe="' + esc(s.k) + '" aria-pressed="' + on + '">' + esc(s.t) + '<small>' + num(s.n) + '</small></button>';
    }).join('');
    /* צבע (רק כשהשרת מצא מסנן צבע): עיגול + שם, ✓ בנבחר, מושבת כשאין פריטים. בלי מונה מתחת לשם (מפרט §4ב) */
    if (colorBox && colorSec) {
      var cv = (live.colors || []).filter(function (c) { return c.n > 0 || pend.colors.indexOf(c.k) >= 0; });
      colorSec.hidden = !cv.length;
      colorBox.innerHTML = cv.map(function (c) {
        var on = pend.colors.indexOf(c.k) >= 0, sw = swatch(c);
        return '<button type="button" class="shc-color' + (on ? ' is-on' : '') + '" data-shc-pcolor="' + esc(c.k) + '" aria-pressed="' + on + '"' + (c.n === 0 && !on ? ' disabled' : '') + '><i class="' + (sw.light ? 'is-light' : '') + '" style="background:' + esc(sw.bg) + '" aria-hidden="true">' + (on ? '✓' : '') + '</i><bdi>' + esc(c.t) + '</bdi></button>';
      }).join('');
    }
    var vs = (live.vendors || []).filter(function (v) { return v.n > 0 || pend.brands.indexOf(v.k) >= 0; });
    var nb = vs.length;
    root.querySelector('[data-shc-nbrands]').textContent = nb === 1 ? 'מותג אחד' : nb + ' מותגים';
    var top = vs.slice().sort(function (a, b) { return b.n - a.n || a.k.localeCompare(b.k); }).slice(0, 6);
    pend.brands.forEach(function (b) { if (!top.some(function (t) { return t.k === b; })) { top.unshift(vs.find(function (v) { return v.k === b; }) || { k: b, n: 0 }); } });
    top.sort(function (a, b) { return (pend.brands.indexOf(b.k) >= 0) - (pend.brands.indexOf(a.k) >= 0); });
    root.querySelector('[data-shc-topbrands]').innerHTML = top.map(function (v) {
      var on = pend.brands.indexOf(v.k) >= 0;
      return '<button type="button" class="shc-bchip' + (on ? ' is-on' : '') + '" data-shc-pbrand="' + esc(v.k) + '" aria-pressed="' + on + '"><bdi>' + esc(v.k) + '</bdi><small>' + num(v.n) + '</small></button>';
    }).join('');
    var all = root.querySelector('[data-shc-allbrands]');
    all.textContent = 'כל המותגים (' + nb + ')';
    all.hidden = nb <= 6;
    root.querySelector('[data-shc-brand-sec]').hidden = nb === 0 && !pend.brands.length;
    renderBrandList();
    root.querySelector('[data-shc-prices]').innerHTML = BUCKETS.map(function (b, i) {
      var n = live.prices ? live.prices[i] : null, on = pend.price === i;
      return '<button type="button" class="shc-chip shc-chip--price' + (on ? ' is-on' : '') + '" data-shc-pprice="' + i + '" aria-pressed="' + on + '"' + (n === 0 && !on ? ' disabled' : '') + '>' + ltr(esc(bucketLabel(b)), bucketLabel(b)) + '<small>' + (n === null ? '' : num(n)) + '</small></button>';
    }).join('');
    var X = live.total;
    applyBtn.disabled = X === 0;
    applyBtn.textContent = X === 0 ? 'אין פריטים בבחירה הזו' : (X === 1 ? 'הצגת פריט אחד' : 'הצגת ' + X + ' פריטים');
    restoreFocus();
  }
  /* פוקוס: render() מצייר מחדש את הכפתורים (גם מיד וגם כשהמונים חוזרים). זוכרים איזה כפתור היה בפוקוס ומחזירים אליו בסוף כל ציור */
  var focusKey = null;
  function keepFocus(el, attr) {
    focusKey = (document.activeElement === el || el.contains(document.activeElement)) ? { attr: attr, val: el.getAttribute(attr), box: el.closest('[data-shc-blist]') ? '[data-shc-blist]' : (el.closest('[data-shc-topbrands]') ? '[data-shc-topbrands]' : null) } : null;
  }
  function restoreFocus() {
    if (!focusKey || sheet.hidden) return;
    var scope = focusKey.box ? root.querySelector(focusKey.box) : sheet;
    var el = [].slice.call(scope.querySelectorAll('[' + focusKey.attr + ']')).find(function (x) { return x.getAttribute(focusKey.attr) === focusKey.val; });
    if (el && el.offsetParent && document.activeElement !== el) el.focus();
  }
  function renderBrandList() {
    var q = (bsearch.value || '').trim().toLowerCase();
    var vs = (live.vendors || []).slice().sort(function (a, b) {
      var sa = pend.brands.indexOf(a.k) >= 0, sb = pend.brands.indexOf(b.k) >= 0;
      if (sa !== sb) return sa ? -1 : 1;
      return a.k.localeCompare(b.k);
    }).filter(function (v) { return !q || v.k.toLowerCase().indexOf(q) >= 0; });
    root.querySelector('[data-shc-blist]').innerHTML = vs.map(function (v) {
      var on = pend.brands.indexOf(v.k) >= 0;
      return '<li><button type="button" data-shc-pbrand="' + esc(v.k) + '" aria-pressed="' + on + '"' + (v.n === 0 && !on ? ' disabled' : '') + '><i aria-hidden="true">' + (on ? '✓' : '') + '</i><bdi>' + esc(v.k) + '</bdi><span>' + num(v.n) + '</span></button></li>';
    }).join('');
  }
  function showBrands(on) {
    main.hidden = on; brandsView.hidden = !on; backBtn.hidden = !on; titleEl.hidden = on;
    if (on) { bsearch.value = ''; renderBrandList(); bsearch.focus(); }
  }
  function openSheet(o, toColor) {
    opener = o || null;
    pend = copySel(cur);
    sheet.hidden = false; scrim.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    showBrands(false);
    render(); refresh();
    /* כפתור "צבע": אותה מגירה, גלולה אל קבוצת הצבע, והפוקוס על הכותרת שלה */
    var ch = toColor ? root.querySelector('[data-shc-color-h]') : null;
    if (ch && colorSec && !colorSec.hidden) {
      try { ch.scrollIntoView({ block: 'start' }); } catch (e) {}
      try { ch.focus({ preventScroll: true }); } catch (e2) { ch.focus(); }
    } else {
      root.querySelector('.shc-x').focus();
    }
  }
  function closeSheet() {
    if (sheet.hidden) return;
    focusKey = null;
    sheet.hidden = true; scrim.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener) opener.focus();
  }
  function setSize(k) { var n = without(pend, 'size', pend.size); if (pend.size !== k) { n.size = k; n.order.push(['size', k]); } return n; }
  function setPrice(i) { var n = without(pend, 'price', pend.price); if (pend.price !== i) { n.price = i; n.order.push(['price', i]); } return n; }
  function toggleList(list, kind, v) { if (pend[list].indexOf(v) >= 0) return without(pend, kind, v); var n = copySel(pend); n[list].push(v); n.order.push([kind, v]); return n; }

  root.addEventListener('click', function (e) {
    var t, base;
    if ((t = e.target.closest('[data-shc-rm]'))) {
      var kv0 = t.getAttribute('data-shc-rm').split('|');
      choose(without(target || cur, kv0[0], kv0[0] === 'price' ? Number(kv0[1]) : kv0.slice(1).join('|')));
      return;
    }
    /* צ'יפ מידה: קישור אמיתי (עובד גם לפני שהסקריפט נטען). כאן מיירטים: בחירה אחת, לחיצה שנייה מבטלת.
       לחיצה עם Ctrl/Cmd/Shift או כפתור אמצעי נשארת של הדפדפן */
    if ((t = e.target.closest('.shc-qs [data-shc-size]'))) {
      if (!plainClick(e)) return;
      e.preventDefault();
      base = target || cur;
      var k0 = t.getAttribute('data-shc-size');
      var n0 = without(base, 'size', base.size);
      if (base.size !== k0) { n0.size = k0; n0.order.push(['size', k0]); }
      choose(n0);
      return;
    }
    if ((t = e.target.closest('.shc-qs [data-shc-qshoe]'))) {
      if (!plainClick(e)) return;
      e.preventDefault();
      base = target || cur;
      var v0 = t.getAttribute('data-shc-qshoe');
      if (base.shoes.indexOf(v0) >= 0) { choose(without(base, 'shoe', v0)); }
      else { var n1 = copySel(base); n1.shoes.push(v0); n1.order.push(['shoe', v0]); choose(n1); }
      return;
    }
    if ((t = e.target.closest('[data-shc-open]'))) { openSheet(t, t.getAttribute('data-shc-open') === 'color'); return; }
    if (e.target.closest('[data-shc-close]')) { closeSheet(); return; }
    if (e.target.closest('[data-shc-back]')) { showBrands(false); root.querySelector('[data-shc-allbrands]').focus(); return; }
    if (e.target.closest('[data-shc-allbrands]')) { showBrands(true); return; }
    if ((t = e.target.closest('[data-shc-psize]'))) { keepFocus(t, 'data-shc-psize'); pend = setSize(t.getAttribute('data-shc-psize')); render(); refresh(); return; }
    if ((t = e.target.closest('[data-shc-pshoe]'))) { keepFocus(t, 'data-shc-pshoe'); pend = toggleList('shoes', 'shoe', t.getAttribute('data-shc-pshoe')); render(); refresh(); return; }
    if ((t = e.target.closest('[data-shc-pcolor]'))) { keepFocus(t, 'data-shc-pcolor'); pend = toggleList('colors', 'color', t.getAttribute('data-shc-pcolor')); render(); refresh(); return; }
    if ((t = e.target.closest('[data-shc-pbrand]'))) { keepFocus(t, 'data-shc-pbrand'); pend = toggleList('brands', 'brand', t.getAttribute('data-shc-pbrand')); render(); refresh(); return; }
    if ((t = e.target.closest('[data-shc-pprice]'))) { keepFocus(t, 'data-shc-pprice'); pend = setPrice(Number(t.getAttribute('data-shc-pprice'))); render(); refresh(); return; }
    if ((t = e.target.closest('[data-shc-prm]'))) { var kv = t.getAttribute('data-shc-prm').split('|'); pend = without(pend, kv[0], kv[0] === 'price' ? Number(kv[1]) : kv.slice(1).join('|')); render(); refresh(); return; }
    if (e.target.closest('[data-shc-clear]')) { pend = emptySel(); render(); refresh(); return; }
    if (e.target.closest('[data-shc-apply]')) {
      var sel = copySel(pend);
      /* המונים "בלי המידה" של הבחירה הזו כבר נשלפו במגירה: הרצועה לא תצטרך בקשה נוספת */
      if (liveKey === selKey(sel) && live.sizes) { baseKey = liveKey; baseSizes = live.sizes; }
      closeSheet();
      choose(sel);
    }
  });
  /* הצ'יפים הם קישורים עם role=button: רווח מפעיל אותם כמו כפתור */
  root.addEventListener('keydown', function (e) {
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.matches && e.target.matches('a.shc-qchip')) { e.preventDefault(); e.target.click(); }
  });
  bsearch.addEventListener('input', function () { focusKey = null; renderBrandList(); });
  document.addEventListener('keydown', function (e) {
    if (sheet.hidden) return;
    if (e.key === 'Escape') { if (!brandsView.hidden) { showBrands(false); root.querySelector('[data-shc-allbrands]').focus(); } else closeSheet(); }
    if (e.key === 'Tab') {
      var f = [].slice.call(sheet.querySelectorAll('button:not([disabled]), input')).filter(function (x) { return x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      /* פוקוס שיצא מהמגירה בזמן שהיא פתוחה חוזר לתוכה */
      else if (f.indexOf(document.activeElement) < 0 && !sheet.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); }
    }
  });
})();
/* ===== fix-lm (20.10): "עוד פריטים" בלי קפיצה של העימוד ושל shani_seo =====
   הבעיה: theme.js (initInfiniteScrolling) טוען את האצווה הבאה רק כשהגלילה עברה את "אזור העימוד פחות 500px",
   כלומר כשהעימוד וטקסט הקטגוריה כבר במסך. 50 כרטיסים נוספים מעליהם (כ-9,000px בנייד) ודוחפים אותם החוצה,
   וגלילה אינה "קלט" ולכן הדפדפן סופר את הקפיצה (0.42 עד 0.50 לכל אצווה).
   התיקון, שני חלקים, בלי לגעת ב-theme.js:
   1. שמירת מקום: ברגע שבקשת האצווה יוצאת (ajaxPrefilter, כל מפעיל: גלילה, לחיצה, catchUp), נכנס מתחת לרשת מרווח
      בגובה השורות שעומדות להגיע. בלחיצה זה קורה בתוך חלון הקלט, ולכן לא נספר. כשהכרטיסים נוספים המרווח מתכווץ באותה משימה,
      ומתאפס רק כשהוא מחוץ למסך.
   2. טעינה מוקדמת: כשאזור העימוד מתקרב (עד 1.5 מסכים מתחת לתחתית המסך) ועדיין מחוץ למסך, מפעילים את הלחיצה של התבנית
      על הקישור. ההוספה קורית מחוץ למסך, ואין מה לספור. עד load (שבו התבנית רושמת את המטפל שלה) לא מפעילים.
   נשען על: is-loading (הנעילה המשותפת, fix-b), data-shc-hold (A4), shc-loading (C1). */
(function () {
  var LEAD = 1.5;               /* כמה מסכים מתחת לתחתית המסך מתחילים לטעון */
  var ready = false, firing = false, resv = null;
  function grid() { return document.querySelector('ul#main-collection-product-grid.productListing'); }
  function link() { return document.querySelector('.pagination-infinite [data-infinite-scrolling]'); }
  function cards(g) { return g ? g.querySelectorAll(':scope > li.product') : []; }
  if (!grid()) return;
  var pageSize = cards(grid()).length || 50;

  /* כמה כרטיסים יגיעו: עמוד מלא, או מה שנשאר לפי "מתוך N" באזור העימוד */
  function expected(g) {
    var have = cards(g).length, n = pageSize, tot = document.querySelector('#CollectionProductGrid .pagination-page-total');
    var m = tot && /מתוך\s*([\d,]+)/.exec(tot.textContent), t = m ? parseInt(m[1].replace(/,/g, ''), 10) : NaN;
    if (t > have) n = Math.min(pageSize, t - have);
    return n;
  }
  /* עמודות וגובה שורה, מהכרטיסים האחרונים שכבר ברשת */
  function geom(g) {
    var c = cards(g); if (c.length < 2) return null;
    var last = c[c.length - 1], top = last.offsetTop, prevTop = null, cols = 0, i;
    for (i = c.length - 1; i >= 0; i--) { if (c[i].offsetTop !== top) { prevTop = c[i].offsetTop; break; } }
    if (prevTop === null) return null;
    /* מספר העמודות: מהשורה הלפני אחרונה (האחרונה יכולה להיות חלקית) */
    for (i = 0; i < c.length; i++) if (c[i].offsetTop === prevTop) cols++;
    return { cols: Math.max(1, cols), stride: top - prevTop, count: c.length };
  }
  /* שמירת המקום היא מרווח (div) מיד אחרי הרשת, לא min-height על הרשת:
     הרשת היא flex עם שבירת שורות, ו-min-height עליה מותח את השורות הקיימות (נמדד 20.10: כרטיסים גדלו מ-350 ל-532px, CLS 1 לכל אצווה). */
  var sp = null;
  function spacer(g) {
    if (!sp || !sp.isConnected) { sp = document.createElement('div'); sp.className = 'shc-lm-spacer'; sp.setAttribute('aria-hidden', 'true');
      sp.style.cssText = 'display:block;width:100%;height:0;pointer-events:none'; }
    if (sp.previousElementSibling !== g) g.parentNode.insertBefore(sp, g.nextSibling);
    return sp;
  }
  function reserve() {
    var g = grid(); if (!g || resv) return;
    var m = geom(g); if (!m) return;
    var n = expected(g);
    var add = (Math.ceil((m.count + n) / m.cols) - Math.ceil(m.count / m.cols)) * m.stride;
    if (add <= 0) return;
    spacer(g).style.height = add + 'px';
    resv = { total: g.offsetHeight + add };
    g.setAttribute('data-shc-resv', String(add));
  }
  /* מיד אחרי שהכרטיסים נוספו (באותה משימה, לפני ציור): המרווח מתכווץ בדיוק בגובה שנוסף, כך שמה שמתחת לרשת לא זז */
  function settle() {
    var g = grid(); if (!g || !resv || !sp) return;
    sp.style.height = Math.max(0, resv.total - g.offsetHeight) + 'px';
  }
  /* שחרור: רק כשהמרווח מחוץ למסך (אז שינוי הגובה לא נראה ולא נספר) */
  function release() {
    if (!resv || !sp) return;
    var l = link();
    if (l && l.classList.contains('is-loading') && !l.hasAttribute('data-shc-hold')) return;   /* עוד בדרך */
    var r = sp.getBoundingClientRect();
    if (r.height === 0 || r.top > innerHeight + 40 || r.bottom < -40) {
      sp.style.height = '0px'; var g = grid(); if (g) g.removeAttribute('data-shc-resv'); resv = null; }
  }

  /* 1. כל בקשת אצווה, מכל מפעיל */
  function hook() {
    var jq = window.jQuery;
    if (!jq || !jq.ajaxPrefilter || hook.on) return;
    hook.on = true;
    jq.ajaxPrefilter(function (o) {
      var l = link();
      if (!l || !o || o.url !== l.getAttribute('href')) return;
      if (document.documentElement.classList.contains('shc-loading')) return;
      reserve();
      var done = o.complete;
      var ok = o.success;
      o.success = function () { var r = ok && ok.apply(this, arguments); settle(); return r; };
      o.complete = function () { var r = done && done.apply(this, arguments); settle(); release(); return r; };
    });
  }
  hook();
  window.addEventListener('load', hook);

  /* 2. טעינה מוקדמת בגלילה */
  function early() {
    if (!ready || firing || document.documentElement.classList.contains('shc-loading')) return;
    var l = link(); if (!l || l.classList.contains('is-loading') || l.hasAttribute('data-shc-fail')) return;
    var box = l.closest('.pagination') || l, top = box.getBoundingClientRect().top;
    if (top <= innerHeight) return;                         /* כבר במסך: התבנית או הלחיצה מטפלות */
    if (top > innerHeight * (1 + LEAD)) return;            /* עוד רחוק */
    firing = true;
    try { l.click(); } finally { firing = false; }
  }
  /* אם המטפל של התבנית לא רשום, הלחיצה שלנו לא מנווטת ל-?page=N */
  window.addEventListener('click', function (e) { if (firing && !e.defaultPrevented) e.preventDefault(); });
  window.addEventListener('scroll', function () { early(); release(); }, { passive: true });
  window.addEventListener('load', function () { setTimeout(function () { ready = true; early(); }, 0); });
})();
